import { Inject, Injectable } from '@angular/core';
import {mbeConfigService} from './mbe-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RiskClassInterface } from '../..';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** API response shape for /rcl/allriskclass returns { items: RiskClassInterface[] }. 05/02/2026 PK. */
export interface RiskClassAPIResponse {
  items: RiskClassInterface[];
}

@Injectable({
  providedIn: 'root'
})
export class RiskClassService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllNotifications(): Observable<RiskClassInterface[]> {
    const headers = this.headers;
    // Map API response { items: [...] } to array so dropdown receives RiskClassInterface[]. 05/02/2026 PK.
    return this.httpClient
      .get<RiskClassAPIResponse>(`${this.URL}/rcl/allriskclass`, { headers })
      .pipe(map((res) => (res && Array.isArray(res.items) ? res.items : [])));
  }
}

